exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media (min-width:768px) and (max-width:1024px){.iconBtn{height:22px;width:22px}}", "", {"version":3,"sources":["/usr/src/app/clientV2/node_modules/botoxs2/src/assets/css/mediaQueries.css"],"names":[],"mappings":"AAAA,gDACE,SACE,YAAa,AACb,UAAY,CACb,CACF","file":"mediaQueries.css","sourcesContent":["@media (min-width: 768px) and (max-width: 1024px) {\n  .iconBtn {\n    height: 22px;\n    width: 22px;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/botoxs2/src/assets/css/mediaQueries.css
// module id = tO7x
// module chunks = 66